// VERSION 1.0.0
// AUTHOR: AGALYA

const CommonTransferLogActionTypes = {
	/*************** FETCH TRANSFER LOG START  ******************/
	FETCH_TRANSFER_LOG_LIST_START: 'fetch_transfer_log_list_start',
	FETCH_TRANSFER_LOG_LIST_SUCCESS: 'fetch_transfer_log_list_success',
	FETCH_TRANSFER_LOG_LIST_FAILURE: 'fetch_transfer_log_list_failure',
	FETCH_TRANSFER_LOG_LIST_RESPONSE_RESET_START: 'fetch_transfer_log_list_response_reset_start',
	FETCH_TRANSFER_LOG_LIST_RESPONSE_CHANGED: 'fetch_transfer_log_list_response_changed',
	/*************** FETCH TRANSFER LOG END  ******************/

	/***************  GET MEMBER APPROVE LIST START  ******************/
	GET_MEMBER_APPROVE_LIST_START: 'get_member_approve_list_start',
	GET_MEMBER_APPROVE_LIST_SUCCESS: 'get_member_approve_list_success',
	GET_MEMBER_APPROVE_LIST_FAILURE: 'get_member_approve_list_failure',
	GET_MEMBER_APPROVE_LIST_RESPONSE_RESET_START: 'get_member_approve_list_response_reset_start',
	GET_MEMBER_APPROVE_LIST_RESPONSE_CHANGED: 'get_member_approve_list_response_changed',
	/***************  GET MEMBER APPROVE LIST END  ******************/

	/***************  CHANGE STATUS TRANSFER LOG START ******************/
	CHANGE_STATUS_TRANSFER_LOG_START: 'change_status_transfer_log_start',
	CHANGE_STATUS_TRANSFER_LOG_SUCCESS: 'change_status_transfer_log_success',
	CHANGE_STATUS_TRANSFER_LOG_FAILURE: 'change_status_transfer_log_failure',
	CHANGE_STATUS_TRANSFER_LOG_RESPONSE_RESET_START:
		'change_status_transfer_log_response_reset_start',
	CHANGE_STATUS_TRANSFER_LOG_RESPONSE_CHANGED: 'change_status_transfer_log_response_changed',
	/***************  CHANGE STATUS TRANSFER LOG END ******************/

	/*********  MEMBER FOR TRANSFER CENTER START *********/
	MEMBER_FOR_TRANSFER_CENTER_START: 'member_for_transfer_center_start',
	MEMBER_FOR_TRANSFER_CENTER_SUCCESS: 'member_for_transfer_center_success',
	MEMBER_FOR_TRANSFER_CENTER_FAILURE: 'member_for_transfer_center_failure',
	MEMBER_FOR_TRANSFER_CENTER_RESPONSE_RESET_START:
		'member_for_transfer_center_response_reset_start',
	MEMBER_FOR_TRANSFER_CENTER_RESPONSE_CHANGED: 'member_for_transfer_center_response_changed',
	/*********  MEMBER FOR TRANSFER CENTER END *********/
};
export default CommonTransferLogActionTypes;
